import logo from "../../assets/images/addmix/logo2.png";
import classes from "./SideMenu.module.scss";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import words from "../../assets/words";
import {useLocation } from "react-router-dom";
import { TbBrandUnity, TbHierarchy } from "react-icons/tb";
import { FaWarehouse } from "react-icons/fa";
import { useNavigate } from "react-router-dom/dist/umd/react-router-dom.development";
import { HiColorSwatch } from "react-icons/hi";
import { FiShoppingCart, FiTag } from "react-icons/fi";
import { MdPlace } from "react-icons/md";

const SideMenu = () => {
  const location = useLocation().pathname;
  const { language } = useSelector((state) => state.auth);
  const [activeTab, setActiveTab] = useState(location);

  const navigate= useNavigate();

  const tabs = [
    {
      icon: <TbBrandUnity size={25} />,
      text: words.PRODUCTS[language],
      href: "/products",
    },
    {
      icon: <FaWarehouse size={25} />,
      text: words.STOCK[language],
      href: "/stocks",
    },
    {
      icon: <TbHierarchy size={25} />,
      text: words.CATEGORY_MANAGEMENT[language],
      href: "/catalog-management",
    },
    {
      icon: <HiColorSwatch size={25} />,
      text: words.COLORS_SIZES_MANAGEMENT[language],
      href: "/attributes-management",
    },
    {
      icon: <FiTag size={25} />,
      text: words.PROMO_CODES_MANAGEMENT[language],
      href: "/promo-codes",
    },
    {
      icon: <FiShoppingCart size={25} />,
      text: words.ORDERS_MANAGEMENT[language],
      href: "/orders-management",
    },
    {
      icon: <MdPlace size={25} />,
      text: words.STATES[language],
      href: "/states",
    }
    // ,
    // {
    //   icon: <TiBusinessCard />,
    //   text: words.CATEGORIES[language],
    //   href: "/users",
    // },
    // {
    //   icon: <FiUsers />,
    //   text: words.ADMINS[language],
    //   href: "/billing",
    // },
    // {
    //   icon: <BiDollar />,
    //   text: words.ORDERS[language],
    //   href: "/billing",
    // },
  ];

  useEffect(() => {
      navigate(activeTab)
  }, [activeTab]);

  return (
    <div className={classes.sideMenu}>
      <img src={logo} alt="logo pic" />
      <div className={classes.content}>
        {tabs.map((tab, index) => {
          if(activeTab === "/") setActiveTab(tabs[0].href)
          return (
            <div
              key={index}
              className={`${activeTab === tab.href ? classes.active : classes.unActive
                }`}
              onClick={() => setActiveTab(tab.href)}
            >
              {tab.icon}
              <p>{tab.text}</p>
            </div>
          );
        })}
      </div>
    </div>
  );
};
export default SideMenu;
